// OperationForm.jsx
import React from "react";

const OperationForm = ({ onSubmit, onClose }) => {
  return (
    <div className="form-overlay">
      <div className="form-container">
        <button className="close-button" onClick={onClose}>
          X
        </button>
        <h2> Operation Creation Form </h2>
        <form onSubmit={onSubmit}>
          <label>Community Health Identifier (CHI): </label>
          <input
            type="text"
            name="chi"
            placeholder="Enter CHI"
            required
          />

          <label>Surgeon ID: </label>
          <input
            type="text"
            name="surgeonId"
            placeholder="Enter Surgeon ID"
            required
          />

          <label>Operation Type: </label>
          <select name="operationType" required>
            <option value="HipReplacement">Hip Replacement</option>
            <option value="KneeReplacement">Knee Replacement</option>
          </select>

          <label>Surgery Side: </label>
          <select name="surgerySide" required>
            <option value="Left">Left</option>
            <option value="Right">Right</option>
          </select>

          <label>Waiting Since: </label>
          <input type="date" name="waitingSince" required />

          <label>Provisional Theatre Date: </label>
          <input type="date" name="theatreDate" required />

          <label>Pain Level: </label>
          <select name="painLevel" required>
            <option value="Minimal">Minimal</option>
            <option value="Moderate">Moderate</option>
            <option value="Extreme">Extreme</option>
          </select>

          <label>Impact on ADLs: </label>
          <select name="adl" required>
            <option value="NoneToModerate">None to moderate</option>
            <option value="UnableToPerform">Unable to perform</option>
          </select>

          <label>Mobility: </label>
          <select name="mobility" required>
            <option value="MinimalLoss">Minimal Loss</option>
            <option value="ModerateLoss">Moderate Loss</option>
            <option value="CompleteLoss">Complete Loss</option>
          </select>

          <label>Radiological Severity: </label>
          <select name="radioSeverity" required>
            <option value="AsExpected">As expected</option>
            <option value="LikelihoodOfHarm">Likelihood of harm with delay</option>
            <option value="RiskOfHarm">Risk of harm with delay</option>
          </select>

          <label>Impairment of current employment/carer role: </label>
          <select name="workOrCareImpairment" required>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>

          <label>Severe mental health impairment or suicidal ideation: </label>
          <select name="mentalHealthImpairment" required>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>

          <label>NTC suitability: </label>
          <select name="ntcSuitability" required>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>

          <label>Patient willing to attend NTC for treatment: </label>
          <select name="ntcAttendance" required>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>

          <label>Robotic Surgery: </label>
          <select name="roboticSurgery" required>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>

          <label>HDU/ITU bed requirement: </label>
          <select name="bedRequired" required>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>

          <label>Pre-assessment status: </label>
          <select name="preassessmentPassed" required>
            <option value="true">Passed</option>
            <option value="false">Failed</option>
          </select>

          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default OperationForm;